/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CrownView } from '@sick-davinci/device-communication';
/**
 * A specific CrownView which works as am adapter between incoming data (onPresentAdd) and Director#handleCapData,
 * by wrapping the payload inside the CapData structure.
 */
export class CrownViewCapData extends CrownView {
    constructor(connection, protocol, viewID) {
        super(connection, protocol, viewID);
        this._onPresentAddCapData = new Array();
        this._onPresentUpdateDecorationCapData = new Array();
        this._onPresentCamera = new Array();
        //on presentAdd to capData
        super.onPresentAdd((Type, Iconics, iconicId, parentId, Decorations) => {
            const capData = {
                payload: {
                    Type,
                    Iconics,
                    Decorations,
                },
                name: iconicId,
                parent: parentId,
                tag: Type,
                funcName: 'call'
            };
            this._onPresentAddCapData.forEach((func) => func(capData));
        });
        //on presentUpdateDecoration to capData
        super.onPresentUpdateDecoration((iconicId, decoration) => {
            const capData = {
                payload: {
                    Type: decoration.class,
                    IconicId: iconicId,
                    Decoration: decoration,
                },
                name: iconicId,
                funcName: 'update',
            };
            this._onPresentUpdateDecorationCapData.forEach((func) => func(capData));
        });
        //on presentCamera to CameraDesc
        super.onPresentCamera((pos, target, up) => this._onPresentCamera.forEach((cam) => {
            const cd = {
                name: cam.name,
                from: !!pos ? [pos.x, pos.y, pos.z] : undefined,
                to: !!target ? [target.x, target.y, target.z] : undefined,
                up: !!up ? [up.x, up.y, up.z] : undefined,
            };
            cam.setCam(cd);
        }));
    }
    onPresentAddCapData(func) {
        this._onPresentAddCapData.push(func);
    }
    onPresentUpdateDecorationCapData(func) {
        this._onPresentUpdateDecorationCapData.push(func);
    }
    onPresentCameraCamDesc(defaultCamName, func) {
        this._onPresentCamera.push({ name: defaultCamName, setCam: func });
    }
}
//# sourceMappingURL=CrownViewCapData.js.map